// extracted by mini-css-extract-plugin
export default {"moreInfo":"morebookinfo_moreInfo__du5du","pageContent":"morebookinfo_pageContent__jZqEX"};